<template>
    <div class="card container singleIconCard">

        <img src="https://i.ibb.co/BC5m6Rn/aboutMe.png" class="card-img-top" /> <br>

        <div class="card-body">
            <p class="card-text">My name is Guilherme Ribeiro and I'm a Computer Science Student from Portugal.
                <br><br>
                I created ROFT to connect with people through my work.
                <br>
                I love to work with software and design and get involved in creative and inovative projects. 
                Here you can see some of my individual work such as Apps and other Software projects developed by me, as well as other design projects I might work on.
                <br><br>
                Hope you like it. If you want some more information or just support my work you can
                <a href="mailto:roft.comp@gmail.com">contact me</a> or visit my Social Media accounts.
            </p>
        </div>

</div>
</template>

<style>

.singleIconCard{
    max-width: 20cm;
}

.infoText {
    color: white;
}

.card {
    background-color: black;
}

.card-title {
    color: white;
}

.card-text {
    color: white
}
</style>
